import { render } from "./rigsbq.vue?vue&type=template&id=d79898f0"
import script from "./rigsbq.vue?vue&type=script&lang=js"
export * from "./rigsbq.vue?vue&type=script&lang=js"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__